// FALLBACK (seit B3): Die maßgebliche Phasen-Konfiguration kommt aus dem
// Backend (GET /pipeline-config/, im Django-Admin gepflegt) und wird über
// den PipelineConfigProvider bezogen. Diese Konstanten dienen nur noch als
// Startwert vor der Antwort bzw. Notnagel bei API-Fehlern — hier nichts
// mehr pflegen, Änderungen gehören in den Admin.

export const LEAD_PHASES = [
  {
    key: 'Open', label: 'Offen',
    next: 'Erstkontakt vorbereiten',
    checklist: ['Quelle & Ansprechpartner erfasst', 'Erstansprache geplant'],
  },
  {
    key: 'Contacted', label: 'Kontaktiert',
    next: 'Interesse qualifizieren',
    checklist: ['Erstkontakt gesendet', 'Rückmeldung nachgehalten', 'Bedarf notiert'],
  },
  {
    key: 'Interested', label: 'Interessiert',
    next: 'Angebot vorbereiten',
    checklist: ['Bedarf qualifiziert', 'Termin vereinbart', 'Angebot erstellt'],
  },
  {
    key: 'Closed Won', label: 'Gewonnen',
    next: 'In Kontakt umwandeln',
    checklist: ['Zusage erhalten', 'Konvertierung vorbereitet'],
  },
];

export const LEAD_LOST = { key: 'Declined', label: 'Abgelehnt' };
